import type { PlatformProfileUserRole } from '@nucleus-commerce/api-client/platform';

/**
 * Platform users carry a role, not permission strings. Owners and admins provision, suspend
 * and reactivate organizations and manage platform users; support and read_only see everything
 * but change nothing. Only owners touch owner accounts.
 */
export const MANAGING_ROLES: ReadonlySet<PlatformProfileUserRole> = new Set(['owner', 'admin']);

export function canManageOrganizations(role: PlatformProfileUserRole | undefined): boolean {
  return role !== undefined && MANAGING_ROLES.has(role);
}

export function canManageUsers(role: PlatformProfileUserRole | undefined): boolean {
  return role !== undefined && MANAGING_ROLES.has(role);
}

/** Exchange rates feed store pricing; the same two roles that provision tenants may record them. */
export function canManageExchangeRates(role: PlatformProfileUserRole | undefined): boolean {
  return role !== undefined && MANAGING_ROLES.has(role);
}

export function isOwner(role: PlatformProfileUserRole | undefined): boolean {
  return role === 'owner';
}

/** Operations checks (the email test) talk to real infrastructure; owners and admins run them. */
export function canRunOperationsChecks(role: PlatformProfileUserRole | undefined): boolean {
  return role !== undefined && MANAGING_ROLES.has(role);
}

/** Brand applications: every role reads them; owners and admins add notes, approve and reject. */
export function canManageApplications(role: PlatformProfileUserRole | undefined): boolean {
  return role !== undefined && MANAGING_ROLES.has(role);
}
